import React, { useEffect, useState } from 'react';
import {
  Button,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import IntlCurrencyInput from 'react-intl-currency-input';
import { toast } from 'react-toastify';
import api from '~/services/api';
import { formatPrice } from '~/util/format';

const CURRENCY_CONFIG = {
  locale: 'pt-BR',
  formats: {
    number: {
      BRL: {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
    },
  },
};

export default function BoostIncentiveModal({
  isOpen,
  toggle,
  saleId,
  role,
  currentIncentive = 0,
  minimumIncentive = 0,
  operatorLabel,
  onSuccess,
}) {
  const [increment, setIncrement] = useState(0);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (isOpen) setIncrement(0);
  }, [isOpen]);

  const total = Number(currentIncentive || 0) + Number(increment || 0);

  const handleSubmit = async () => {
    if (!increment || increment <= 0) {
      toast.error('Informe um valor maior que zero.');
      return;
    }

    if (minimumIncentive > 0 && total < minimumIncentive) {
      toast.error(
        `O incentivo total precisa ser de no mínimo R$ ${Number(
          minimumIncentive
        )
          .toFixed(2)
          .replace('.', ',')}.`
      );
      return;
    }

    setSaving(true);

    try {
      await api.patch(`${role}/carts/${saleId}/delivery/boost-incentive`, {
        increment,
      });

      toast.success('Incentivo aplicado!');
      toggle();

      if (onSuccess) onSuccess();
    } catch (err) {
      toast.error(
        err?.response?.data?.message || 'Não foi possível aplicar o incentivo.'
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Aumentar incentivo</ModalHeader>
      <ModalBody>
        <p className="font-size-14 text-muted">
          O valor é somado ao incentivo já aplicado na busca atual em{' '}
          <b>{operatorLabel}</b>, sem cancelar a entrega.
        </p>

        <div className="border rounded p-3 mb-3">
          <div className="font-size-14 text-gray-600">Incentivo atual</div>
          <div className="font-size-24 font-weight-700 text-black">
            {formatPrice(currentIncentive || 0)}
          </div>
        </div>

        <FormGroup>
          <Label>Quanto deseja acrescentar?</Label>
          <IntlCurrencyInput
            currency="BRL"
            onChange={(_, value) => setIncrement(value)}
            value={increment}
            className="w-100 form-control"
            config={CURRENCY_CONFIG}
          />
        </FormGroup>

        {increment > 0 && (
          <div className="font-size-14">
            O incentivo total passa a ser{' '}
            <b className="text-primary">{formatPrice(total)}</b>.
          </div>
        )}

        {minimumIncentive > 0 && (
          <div className="font-size-12 text-muted mt-2">
            {operatorLabel} exige incentivo total de no mínimo R${' '}
            {Number(minimumIncentive).toFixed(2).replace('.', ',')}.
          </div>
        )}

        <div className="font-size-12 text-muted mt-3">
          O incentivo não pode ser reduzido — as transportadoras só aceitam
          aumento.
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle} disabled={saving}>
          Cancelar
        </Button>
        <Button
          color="primary"
          className="new-layout-btn main"
          onClick={handleSubmit}
          disabled={saving || !increment}
        >
          {saving ? 'Aplicando...' : 'Aplicar incentivo'}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
